import {
    ComboboxData,
    Input,
    InputWrapperProps,
    Select,
    SelectProps,
    TextInput,
    TextInputProps,
} from "@mantine/core";
import { useEffect, useRef } from "react";
import { useFormHelperContext } from "../form";
import {
    useController,
    useFieldArray,
    useForm,
    useFormState,
} from "react-hook-form";
import { InputWrapper } from "../inputWrapper";

export interface FieldInputDropdownProps extends SelectProps {
    label: string;
    name: string;
    inputWrapper?: InputWrapperProps;
    data: ComboboxData | undefined;
    disabled?: boolean;
}

export const FieldInputDropdown: React.FC<FieldInputDropdownProps> = ({
    label,
    name,
    placeholder,
    inputWrapper,
    disabled,
    data,
    readOnly,
    ...rest
}) => {
    const { register, control, formStore } = useFormHelperContext();
    const {
        field,
        fieldState: { error },
    } = useController({ name, control });

    if (!register) {
        throw new Error("Field.Dropdown must be used within a FormHelper component");
    }

    return (
        <InputWrapper
            label={label}
            {...inputWrapper}
            withAsterisk={rest.withAsterisk}>
            <div className="flex flex-col w-full">
                <Select
                    data={data}
                    data-testid={'field-dropdown-' + name}
                    // readOnly={readOnly ?? formStore.readOnly}
                    {...field}
                    placeholder={placeholder}
                    value={field.value ?? ""}
                    error={error ? " " : undefined}
                    nothingFoundMessage={"No data found"}
                    {...rest}
                    disabled={disabled || false}
                />
                {error && <Input.Error>{error.message}</Input.Error>}
            </div>
        </InputWrapper>
    );
};
